import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { Msg, useMsg } from "../../components/Msg/Msg";
import { messages } from "../Availability/AvailabilityCalendar";
export const CoachCardBtns = ({
  coach,
  pickedCoach,
  onPick,
  pickPending,
  onContact,
  calendarVisible,
  setCalendarVisible,
}) => {
  const msg = useMsg({ dict: messages });
  const ControlsContainer2 = ({ sx, ...props }) => {
    return (
      <Box
        sx={{
          ...sx,
        }}
        {...props}
      />
    );
  };

  return (
    (onContact || onPick) && (
      <ControlsContainer2
        sx={{
          mt: 1,
          justifyContent: "flex-end",
          display: "flex",
          width: "100%",
          alignItems: "baseline",
          gap: 3,
        }}
      >
        {onPick && (
          <Button
            variant="outlined"
            onClick={() =>
              onPick(pickedCoach === coach.username ? null : coach.username)
            }
            loading={pickPending}
          >
            {pickedCoach === coach.username
              ? msg("coaches.coach.change-picked")
              : msg("coaches.coach.pick")}
          </Button>
        )}{" "}
        <Button
          variant="outlined"
          onClick={() => setCalendarVisible((prev) => !prev)}
        >
          {calendarVisible
            ? msg("availability-calendar.hide.btn")
            : msg("availability-calendar.check.btn")}
        </Button>
        {onContact && (
          <Button variant="contained" onClick={onContact}>
            <Msg id="coaches.coach.contact" />
          </Button>
        )}
      </ControlsContainer2>
    )
  );
};
